/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Client_BodyInputs */

const en_features_client_body = /** @type {(inputs: Features_Client_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Their next visit, the sessions left in their pack, their plan and their progress. Everything you would ask about in messages, in one place.`)
};

const pl_features_client_body = /** @type {(inputs: Features_Client_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Następna wizyta, ile treningów zostało w pakiecie, jego plan i postępy. Wszystko, o co pytałbyś w wiadomościach, w jednym miejscu.`)
};

/**
* | output |
* | --- |
* | "Their next visit, the sessions left in their pack, their plan and their progress. Everything you would ask about in messages, in one place." |
*
* @param {Features_Client_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_client_body = /** @type {((inputs?: Features_Client_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Client_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_client_body(inputs)
	return en_features_client_body(inputs)
});